<template>
    <RouterView />
</template>
<script>
export default {
  watch: {
    $route (to, from) {
      document.title = to.meta.title || 'Nexus Technology'
      const metaTags = document.querySelectorAll('meta[name], meta[property], link[rel="canonical"]')
      metaTags.forEach(tag => tag.parentNode.removeChild(tag))

      if (to.meta.metaTags) {
        to.meta.metaTags.forEach(tagDef => {
          const tag = document.createElement(tagDef.rel ? 'link' : 'meta')
          Object.keys(tagDef).forEach(key => {
            tag.setAttribute(key, tagDef[key])
          })
          document.head.appendChild(tag)
        })
      }
    }
  }
}
</script>
